export function capitalize(str) {
    if (typeof str !== 'string' || !str) {
        return '';
    }
    return str.charAt(0).toUpperCase() + str.slice(1);
}


export function isInThePast(date) {
    const today = new Date();

    // 👇️ OPTIONAL!
    // This line sets the hour of the current date to midnight
    // so the comparison only returns `true` if the passed in date
    // is at least yesterday
    today.setHours(0, 0, 0, 0);

    return date < today;
}



export const getSiteDomain = ({ site }) => {
    try {
        return ((new URL(site.url)).origin).replace(/^http(s?):\/\//, '').replace(/\/$/, '');
    } catch (e) {
        return site.url.replace(/^http(s?):\/\//, '').replace(/\/$/, '');
    }
};


export const formatNumber = (amount, decimals = 2) => {
  if (amount === null || amount === undefined || isNaN(amount)) return "0";

  const numAmount = parseFloat(amount);
  const hasDecimals = numAmount % 1 !== 0;

  return numAmount.toLocaleString("en-GB", {
    minimumFractionDigits: hasDecimals ? decimals : 0,
    maximumFractionDigits: decimals,
  });
};


// Check if member is a recent member, i.e. created in last 24 hours
export function isRecentMember({ member }) {
    if (!member?.created_at) {
        return false;
    }

    const now = new Date();
    const created = new Date(member.created_at);
    const diff = now.getTime() - created.getTime();
    const diffHours = Math.round(diff / (1000 * 60 * 60));

    return diffHours < 24;
}


export const safeCallback = (callback, arg1, arg2, arg3) => {
    if (!callback) {
        return;
    }

    if (arg3 !== undefined) {
        callback(arg1, arg2, arg3);
        return;
    }
    if (arg2 !== undefined) {
        callback(arg1, arg2);
        return;
    }
    callback(arg1);
};




export const runningOnBrowser = typeof window !== "undefined";

export const isBot =
    (runningOnBrowser && !("onscroll" in window)) ||
    (typeof navigator !== "undefined" && /(gle|ing|ro)bot|crawl|spider/i.test(navigator.userAgent));

export const supportsIntersectionObserver = runningOnBrowser && "IntersectionObserver" in window;

export const supportsClassList = runningOnBrowser && "classList" in document.createElement("p");

export const supportsCreateImageBitmap = runningOnBrowser && "createImageBitmap" in window;

export const supportsFetch = runningOnBrowser && "fetch" in window;

export const isHiDpi = runningOnBrowser && window.devicePixelRatio > 1;


export function plainText(html) {
    // Remove HTML tags, non-breaking spaces, and line breaks
    return html.replace(/<\/?[^>]*>/g, '').replace(/&nbsp;/g, ' ').replace(/<br\s*[/]?>/gi, '\n').trim();
}


export const removeSpaces = (values) => {
    Object.keys(values).forEach((key) =>
        typeof values[key] === "string"
            ? (values[key] = values[key]?.trim()?.replace(/  +/g, " "))
            : values[key]
    );
    return values
}




export const getSrno = (currentPage, pageSize, index) => {
    return (currentPage == 1 ? 0 : (currentPage - 1) * pageSize) + index + 1
}

export const TrimText = (value, size = 40) => {
  return value != undefined && value.length > size
    ? value.slice(0, size) + "..."
    : value;
};

export const capitalizeFirstLetter = (string) => {
    if (!string) return 'NA'; // Return 'NA' if the string is empty or undefined
    return string.charAt(0).toUpperCase() + string.slice(1);
};


export function calculateAge(dateString) {
    const birthDate = new Date(dateString);
    const today = new Date();
  
    if (isNaN(birthDate.getTime())) {
      return '-';
    }
  
    let years = today.getFullYear() - birthDate.getFullYear();
    let months = today.getMonth() - birthDate.getMonth();
    const days = today.getDate() - birthDate.getDate();
  
    if (days < 0) {
      months--;
    }
  
    if (months < 0) {
      years--;
      months += 12;
    }
  
    return `${years} Year${years !== 1 ? 's' : ''} , ${months} Month${months !== 1 ? 's' : ''}`;
  }
  

/**
 * Waiting-period details for a deactivated user, or null when the user is not
 * inactive. The day count and the waiting-period length both come from the
 * backend (the length is a backend env variable), so the admin only decides
 * how to render them.
 */
export const getDeactivationInfo = (user) => {
  if (!user || user.status !== 0 || !user.deactivatedAt) return null;

  const days = Number(user.daysSinceDeactivation);
  if (!Number.isFinite(days)) return null;

  return {
    deactivatedAt: user.deactivatedAt,
    days,
    waitingPeriodDays: user.waitingPeriodDays,
    exceeded: Boolean(user.waitingPeriodExceeded),
  };
};

/** "1 day" / "5 days" for a deactivation day count. */
export const formatDeactivationDays = (days) =>
  `${days} ${days === 1 ? "day" : "days"}`;
